<template>	
	<div class="fxsymbolPrice whiteBG radiusbold">
		<div class="map-nav border-bottom p-2 d-flex align-items-center justify-content-between">
			<ul class="d-flex align-items-center">
               <!--  <li :class="fxsymbolprice == 1? 'active': ''" v-on:click.prevent="fxsymbolprice = 1"><a href="#"> {{$t('topGainers')}}</a></li>
				<li :class="fxsymbolprice == 2? 'active': ''" v-on:click.prevent="fxsymbolprice = 2"><a href="#">{{$t('topLosers')}}</a></li> -->
				<!-- <li :class="fxsymbolprice == 0? 'active': ''" v-on:click.prevent="fxsymbolprice = 0">
                    <select class="fxsymbolselect" v-model="type">
                        <option value="f">{{$t('Forex')}}</option>
                        <option value="c">{{$t('Commodities')}}</option>
                        <option value="i">{{$t('Indices')}}</option>
                    </select>
                </li> -->

                <li :class="fxsymbolprice == 0? 'active': ''" v-on:click.prevent="fxsymbolprice = 0"><a href="#">{{$t('Forex')}}</a></li>
                <li :class="fxsymbolprice == 1? 'active': ''" v-on:click.prevent="fxsymbolprice = 1"><a href="#">{{$t('Commodities')}}</a></li>
                <li :class="fxsymbolprice == 2? 'active': ''" v-on:click.prevent="fxsymbolprice = 2"><a href="#">{{$t('Indices')}}</a></li>

			</ul>
		</div>
        <!-- {{get_top_looser}} --> <!-- {{get_top_gainer}}-{{get_top_looser}} -->
		<div>
			<div class="pricefeed scrollbar tradingIdeas" v-if="fxsymbolprice == 0">
				<div class="table-responsive">
                    <table class="table pmmTable">
                        <thead>
                            <tr>
                                <th>{{$t('symbol')}}</th>
                                <th>{{$t('bid')}}</th>
                                <th>{{$t('ask')}}</th>
                                <th>{{$t('spread')}}</th>
                                <!-- <th>{{$t('change')}}%</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="Object.keys(user_isins).length!=0 " v-for="spreads in user_isins">
                                <td   valign="middle">{{spreads.other.isinid}}</td>
                                <td v-bind:class="[{'green': spreads.buy_increase_staus}, {'red': !spreads.buy_increase_staus}]">{{spreads.B}}</td>

                                <td v-bind:class="[{'green': spreads.sell_increase_staus}, {'red': !spreads.sell_increase_staus}]">{{spreads.A}}</td>
                                <td  valign="middle">{{spreads.SPREAD}}</td>
                            </tr>
                        </tbody>
                    </table>            
                </div>
			</div>
            <div class="pricefeed scrollbar tradingIdeas" v-if="fxsymbolprice == 1">
                <div class="table-responsive">
                    <table class="table pmmTable">
                        <thead>
                            <tr>
                                <th>{{$t('symbol')}}</th>
                                <th>{{$t('bid')}}</th>
                                <th>{{$t('ask')}}</th>
                                <th>{{$t('spread')}}</th>
                                <!-- <th>{{$t('change')}}%</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="Object.keys(get_commodity).length!=0" v-for="spreads in get_commodity">
                                <td   valign="middle">{{spreads.other.isinid}}</td>
                                <td v-bind:class="[{'green': spreads.buy_increase_staus}, {'red': !spreads.buy_increase_staus}]">{{spreads.B}}</td>

                                <td v-bind:class="[{'green': spreads.sell_increase_staus}, {'red': !spreads.sell_increase_staus}]">{{spreads.A}}</td>
                                <td   valign="middle">{{spreads.SPREAD}}</td>
                            </tr>
                        </tbody>
                    </table>            
                </div>
            </div>
            <div class="pricefeed scrollbar tradingIdeas" v-if="fxsymbolprice == 2">
                <div class="table-responsive">
                    <table class="table pmmTable">
                        <thead>
                            <tr>
                                <th>{{$t('symbol')}}</th>
                                <th>{{$t('bid')}}</th>
                                <th>{{$t('ask')}}</th>
                                <th>{{$t('spread')}}</th>
                                <!-- <th>{{$t('change')}}%</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="Object.keys(get_Indices).length!=0" v-for="spreads in get_Indices">
                                <td  valign="middle">{{spreads.other.isinid}}</td>
                                <td v-bind:class="[{'green': spreads.buy_increase_staus}, {'red': !spreads.buy_increase_staus}]">{{spreads.B}}</td>

                                <td v-bind:class="[{'green': spreads.sell_increase_staus}, {'red': !spreads.sell_increase_staus}]">{{spreads.A}}</td>
                                <td   valign="middle">{{spreads.SPREAD}}</td>
                            </tr>
                        </tbody>
                    </table>            
                </div>
            </div>
			<!-- <div class="pricefeed scrollbar tradingIdeas" v-if="fxsymbolprice == 1">
                <table class="table pmmTable">
                    <thead>
                        <tr>
                            <th>{{$t('symbol')}}</th>
                            <th>{{$t('bid')}}</th>
                            <th>{{$t('ask')}}</th>
                            <th>%{{$t('change')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="get_top_gainer && Object.keys(get_top_gainer).length!=0" v-for="spreads in get_top_gainer.item.topGainer">
                            <td  valign="middle">{{spreads}}{{spreads.other.isinid}}</td>
                            <td>{{spreads.B}}</td>
                            <td>{{spreads.A}}</td>
                            <td  valign="middle" class="green">{{spreads.CB.toFixed("2")}}</td>
                        </tr>
                        
                    </tbody>
                </table>
			</div> -->
			<!-- <div class="pricefeed scrollbar tradingIdeas" v-if="fxsymbolprice == 2">
				<table class="table pmmTable">
                    <thead>
                        <tr>
                            <th>{{$t('symbol')}}</th>
                            <th>{{$t('bid')}}</th>
                            <th>{{$t('ask')}}</th>
                            <th>%{{$t('change')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                       <tr v-if="get_top_looser && Object.keys(get_top_looser).length!=0" v-for="spreads in get_top_looser.item.topLooser">
                            <td  valign="middle">{{spreads}}{{spreads.other.isinid}}</td>
                            <td>{{spreads.B}}</td>
                            <td>{{spreads.A}}</td>
                            <td  valign="middle" class="red">{{spreads.CB.toFixed("2")}}</td>
                        </tr>
                        
                    </tbody>
                </table>
			</div> -->
		</div>
	</div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import { ProviderCacheMixins } from '@/plugins/vue-provider-cache/mixin'
     import { Const } from '@/plugins/vue-provider-cache/const.mod'
    export default {
        name: 'Price-feed',
        mixins: [ProviderCacheMixins],
        data() {
            return {
                pageLoader : false,
                fxsymbolprice : 0,
                type: 'f'
            }
        },
        computed: {
            get_commodity(){
               try {
                // just 'feel' the pulse here so we get a reactive response
                // as the cache is not reactive  
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
                return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                  .iCache.getCommodity()
              } catch (ex) {
                // console.log('OO-one [ex]', ex)
                return []
              }
            },
            user_isins() {
              try {
                // just 'feel' the pulse here so we get a reactive response
                // as the cache is not reactive  
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
                return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                  .iCache.asKeysValueArray()
              } catch (ex) {
                // console.log('OO-one [ex]', ex)
                return []
              }
            },
            get_Indices(){
              try {
                // just 'feel' the pulse here so we get a reactive response
                // as the cache is not reactive  
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
                return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                  .iCache.getIndices()
              } catch (ex) {
                // console.log('OO-one [ex]', ex)
                return []
              }
            },
            get_top_gainer(){
              try {
                // just 'feel' the pulse here so we get a reactive response
                // as the cache is not reactive  
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
				console.log('gainer',this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache)
                return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.getTopGainer()
              } catch (ex) {
                // console.log('OO-one [ex]', ex)
                return []
              }
            },
             get_top_looser(){
              try {
                // just 'feel' the pulse here so we get a reactive response
                // as the cache is not reactive  
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
				console.log('looser',this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache)
                return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.getTopLooser()
              } catch (ex) {
                // console.log('OO-one [ex]', ex)
                return []
              }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingAccounts/price_feed.vue